import { render } from "./index.vue?vue&type=template&id=126b135a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=126b135a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-126b135a"
/* hot reload */
if (module.hot) {
  script.__hmrId = "126b135a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('126b135a', script)) {
    api.reload('126b135a', script)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=126b135a&scoped=true", () => {
    api.rerender('126b135a', render)
  })

}

script.__file = "src/layout/components/Settings/index.vue"

export default script